import { type SVGProps } from 'react';

import styles from './MostPopularBets.module.scss';
import { getSportIcon } from './sportIconMap';

type SportIconProps = {
  categoryGroupId: number;
} & SVGProps<SVGSVGElement>;

export const SportIcon = ({ categoryGroupId, ...props }: SportIconProps) => {
  const Icon = getSportIcon(categoryGroupId);
  return (
    <span aria-hidden="true" className={styles.sportIcon} data-testid="most-popular-bets-sport-icon">
      <Icon {...props} />
    </span>
  );
};
